import React, { useEffect, useState } from "react";
import moment from "moment";
import menuIcon from "../../../../../../assets/images/DeathModuleNew/Menu.png";
import { Menu, Dropdown, Progress, Icon } from "antd";
import { useHistory } from "react-router-dom";
import { TotalBudgetTile } from "../AddBudgetMainTile/TotalBudgetTile";
import { BudgetSkeleton } from "../../../../../Skeletons/BudgetSkeleton";
import NewLoader from "../../../../../../components/styled-components/loader/NewLoader";
import { ListViewBudget } from "./ListViewBudget";
import tabViewIcon from "../../../../../../assets/images/tabs/permission.png";
import listViewIcon from "../../../../../../assets/images/tabs/app.png";
export const CategorizedBudget = ({
  transactions,
  budgetData,
  setFormData,
  setSelectedData,
  setAddModal,
  categoryBudget,
  filterData,
  deleteSelectBudget,
  monthsBudgetData,
  notYetBudgetedData,
  setSelectedDataNotBudgeted,
  notYetBudgetedSubcategoryData,
  loading,
}) => {
  const history = useHistory();
  const [selectView, setSelectedView] = useState("tab");
  const [uncategorizedBudget, setUncategorizedBudget] = useState([]);
  const tabViews = [
    {
      id: 1,
      view: "tab",
      icon: tabViewIcon,
      title: "Tile View",
    },
    {
      id: 2,
      view: "list",
      icon: listViewIcon,
      title: "List View",
    },
  ];
  useEffect(() => {
    const notBudgetCategoryWise = (notYetBudgetedData || []).filter(
      (item) =>
        !budgetData.some(
          (e) => !e.subCategoryId && e.categoryId === item.categoryId
        )
    );
    const notBudgetSubCategoryWise = (
      notYetBudgetedSubcategoryData || []
    ).filter(
      (item) =>
        !budgetData.some(
          (e) =>
            e.subCategoryId &&
            item.subCategoryId &&
            e.subCategoryId === item.subCategoryId
        )
    );

    setUncategorizedBudget([
      ...notBudgetCategoryWise,
      ...notBudgetSubCategoryWise,
    ]);
  }, [notYetBudgetedData, notYetBudgetedSubcategoryData]);
  return (
    <div style={{ paddingInline: "4px" }}>
      <TotalBudgetTile
        monthsBudgetData={monthsBudgetData && monthsBudgetData}
        budgetData={budgetData && budgetData}
        categoryBudget={categoryBudget && categoryBudget}
        loading={loading}
      />
      <div className="tab-view-container">
        {tabViews &&
          tabViews.map((item, index) => (
            <div
              key={index}
              className={
                selectView === item.view ? "tab-view-selected" : "tab-view"
              }
              onClick={() => setSelectedView(item.view)}
              title={item.title}
            >
              <img
                className={
                  selectView === item.view
                    ? "seleted-view-selected"
                    : "seleted-view"
                }
                height={16}
                width={16}
                src={item.icon}
                alt={item.view}
              />
            </div>
          ))}
      </div>
      {!budgetData && <BudgetSkeleton />}
      <div
        className="BudgetCards"
        style={{
          justifyContent: "flex-start",
          maxHeight: "54vh",
          overflow: "auto",
        }}
      >
        {selectView === "tab" ? (
          budgetData &&
          budgetData.map((item, index) => {
            const budgetValue =
              categoryBudget &&
              categoryBudget.length > 0 &&
              categoryBudget.find((budget) => {
                if (item.subCategoryId && budget.subCategoryId) {
                  return budget.subCategoryId === item.subCategoryId;
                } else if (budget && budget.categoryId && !item.subCategoryId) {
                  console.log("here in check category", item.categoryId);
                  return budget.categoryId === item.categoryId;
                }
                return false;
              });
            console.log("budgetValue", budgetValue, categoryBudget, budgetData);
            return (
              <div
                key={index}
                className="budgetCardStyle"
                style={{ position: "relative" }}
              >
                <div className="budgetDropDown">
                  <span className="budgetCardTitle">
                    {item.subCategoryId
                      ? `${
                          item.budgetCategory &&
                          item.budgetCategory.categoryName
                        } (${
                          (
                            (item.budgetCategory &&
                              item.budgetCategory.subCategories &&
                              item.budgetCategory.subCategories.find(
                                (sub) => sub.id === item.subCategoryId
                              )) ||
                            {}
                          ).name
                        })`
                      : item.budgetCategory && item.budgetCategory.categoryName}
                  </span>

                  <Dropdown
                    trigger={["click"]}
                    overlay={
                      <Menu>
                        <Menu.Item>
                          <div
                            onClick={() => {
                              setSelectedData(item);
                              let obj = item;
                              console.log("item", item);
                              if (
                                item.budgetCategory &&
                                item.budgetCategory.categoryName
                              ) {
                                const categoryName =
                                  item.budgetCategory.categoryName;
                                const subcategoryName = (
                                  item.budgetCategory.subCategories.find(
                                    (sub) => sub.id === item.subCategoryId
                                  ) || {}
                                ).name;
                                if (subcategoryName) {
                                  obj.categoryName = `${subcategoryName}`;
                                } else {
                                  obj.categoryName = categoryName;
                                }
                              }
                              // if (
                              //   item.budgetCategory &&
                              //   item.budgetCategory.categoryName
                              // ) {
                              //   obj.categoryName =
                              //     item.budgetCategory.categoryName;
                              // }
                              setFormData(obj);
                              setAddModal(true);
                            }}
                          >
                            Edit
                          </div>
                        </Menu.Item>
                        <Menu.Item>
                          <div
                            onClick={() => {
                              deleteSelectBudget(item.id);
                            }}
                          >
                            Delete
                          </div>
                        </Menu.Item>
                      </Menu>
                    }
                  >
                    <div
                      style={{
                        cursor: "pointer",
                        marginRight: "1rem",
                        padding: "0px 16px",
                        width: "5px",
                      }}
                    >
                      <a
                        className="ant-dropdown-link"
                        onClick={(e) => e.preventDefault()}
                      >
                        <img
                          src={menuIcon}
                          height={15}
                          width={4}
                          alt="icon"
                        ></img>
                      </a>
                    </div>
                  </Dropdown>
                </div>
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    console.log("filter", filterData);
                    const currentDate = new Date();
                    let startDate = null;
                    let endDate = null;
                    switch (filterData) {
                      case "This Month":
                        startDate = new Date(
                          currentDate.getFullYear(),
                          currentDate.getMonth(),
                          1
                        );
                        endDate = new Date(
                          currentDate.getFullYear(),
                          currentDate.getMonth() + 1,
                          0
                        );
                        break;
                      case "Last Month":
                        startDate = new Date(
                          currentDate.getFullYear(),
                          currentDate.getMonth() - 1,
                          1
                        );
                        endDate = new Date(
                          currentDate.getFullYear(),
                          currentDate.getMonth(),
                          0
                        );
                        break;
                      case "Last Three Month":
                        startDate = new Date(
                          currentDate.getFullYear(),
                          currentDate.getMonth() - 2,
                          1
                        );
                        endDate = currentDate;
                        break;
                      case "Last Six Month":
                        startDate = new Date(
                          currentDate.getFullYear(),
                          currentDate.getMonth() - 5,
                          1
                        );
                        endDate = currentDate;
                        break;
                      case "This Year":
                        startDate = new Date(currentDate.getFullYear(), 0, 1);
                        endDate = currentDate;
                        break;
                      case "Last Year":
                        startDate = new Date(
                          currentDate.getFullYear() - 1,
                          0,
                          1
                        );
                        endDate = new Date(
                          currentDate.getFullYear() - 1,
                          11,
                          31
                        );
                        break;
                      case "All Time":
                        break;
                      default:
                        startDate = new Date(
                          currentDate.getFullYear(),
                          currentDate.getMonth(),
                          1
                        );
                        endDate = new Date(
                          currentDate.getFullYear(),
                          currentDate.getMonth() + 1,
                          0
                        );
                        break;
                    }
                    console.log("startDate:", startDate, endDate);
                    let filterObj = {
                      id: item.categoryId && item.categoryId,
                      categoryName:
                        item.budgetCategory && item.budgetCategory.categoryName,
                      startDate:
                        startDate && moment(startDate).format("MM/DD/YYYY"),
                      endDate: endDate && moment(endDate).format("MM/DD/YYYY"),
                    };
                    // console.log("location filter",filterObj)
                    history.push(`/budget/add/transaction`, {
                      filterValues: {
                        id: item.categoryId && item.categoryId,
                        categoryName:
                          item.budgetCategory &&
                          item.budgetCategory.categoryName,
                        startDate:
                          startDate && moment(startDate).format("MM/DD/YYYY"),
                        endDate:
                          endDate && moment(endDate).format("MM/DD/YYYY"),
                      },
                    });
                  }}
                >
                  <p style={{ marginTop: "1rem" }}>
                    <span className="cardTotalAmount">
                      $
                      {item.multipliedAmount !== undefined
                        ? `${item.multipliedAmount
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                        : item.amount
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
                    </span>
                    <span className="totalStyle"> Total </span>
                  </p>
                  {/* <Progress
              type="line"
              // strokeColor={"#2a3da3"}
              strokeColor={
                item.amount &&
                budgetValue &&
                budgetValue.value &&
                budgetValue.value.usedAmount
                  ?  budgetValue.value.usedAmount > item.amount
                    ? "#f5222d"
                    : "#2a3da3"
                  : "#2a3da3"
              }
              trailColor="#333533"
              percent={
                item.amount &&
                budgetValue &&
                budgetValue.value &&
                budgetValue.value.usedAmount
                  ? ((budgetValue.value.usedAmount) /
                      item.amount) *
                    100
                  : 0
              }
              style={{ marginTop: "2rem" }}
              showInfo={false}
            /> */}
                  <Progress
                    type="line"
                    strokeColor={
                      item.amount &&
                      ((budgetValue && budgetValue && budgetValue.usedAmount) ||
                        item.totalSpent)
                        ? (item.totalSpent
                            ? item.totalSpent
                            : budgetValue.usedAmount) >
                          (item.multipliedAmount
                            ? item.multipliedAmount
                            : item.amount)
                          ? "#f5222d"
                          : "#2a3da3"
                        : "#2a3da3"
                    }
                    trailColor="#333533"
                    percent={
                      item.amount &&
                      ((budgetValue && budgetValue && budgetValue.usedAmount) ||
                        item.totalSpent)
                        ? ((item.totalSpent
                            ? item.totalSpent
                            : budgetValue.usedAmount) /
                            (item.multipliedAmount
                              ? item.multipliedAmount
                              : item.amount)) *
                          100
                        : 0
                    }
                    style={{ marginTop: "2rem" }}
                    showInfo={false}
                  />
                  <div className="progressLabelCotainer">
                    <div className="progressLabelMain">
                      <div
                        className="progressBox"
                        // style={{
                        //   background:
                        //     item.amount &&
                        //     budgetValue &&
                        //     budgetValue.value &&
                        //     budgetValue.value.leftAmount
                        //       ? item.amount - budgetValue.value.leftAmount >
                        //         item.amount
                        //         ? "#f5222d"
                        //         : "#2a3da3"
                        //       : "#2a3da3",
                        // }}
                        style={{
                          background:
                            item.amount &&
                            ((budgetValue &&
                              budgetValue &&
                              budgetValue.leftAmount) ||
                              item.totalSpent ||
                              item.multipliedAmount)
                              ? (item.multipliedAmount
                                  ? item.multipliedAmount
                                  : item.amount) -
                                  (item.totalSpent
                                    ? item.multipliedAmount - item.totalSpent
                                    : budgetValue && budgetValue.leftAmount) >
                                (item.multipliedAmount
                                  ? item.multipliedAmount
                                  : item.amount)
                                ? "#f5222d"
                                : "#2a3da3"
                              : "#2a3da3",
                        }}
                      ></div>
                      <div className="progressLabel">
                        Used{" "}
                        <p>
                          {item.totalSpent !== undefined
                            ? `$${item.totalSpent
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                            : budgetValue &&
                              budgetValue &&
                              budgetValue.usedAmount
                            ? `$${budgetValue.usedAmount
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                            : "$0"}
                        </p>
                      </div>
                    </div>
                    <div className="progressLabelMain">
                      <div
                        className="progressBox"
                        style={{
                          backgroundColor: "#f5f5f5",
                        }}
                      ></div>
                      <div className="progressLabel">
                        {(() => {
                          // Calculate the amount to display
                          const amount =
                            item.totalSpent !== undefined &&
                            item.multipliedAmount !== undefined
                              ? item.multipliedAmount - item.totalSpent
                              : budgetValue
                              ? budgetValue.leftAmount
                              : item.amount;

                          // Format amount as positive and add commas
                          const formattedAmount = Math.abs(amount)
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                          // Determine label ("Left" or "Over")
                          const label = amount < 0 ? "Over" : "Left";

                          return (
                            <React.Fragment>
                              {label} <p>${formattedAmount}</p>
                            </React.Fragment>
                          );
                        })()}
                      </div>
                    </div>
                  </div>
                </div>
                <NewLoader isLoading={loading} />
              </div>
            );
          })
        ) : (
          <ListViewBudget
            budgetData={budgetData && budgetData}
            categoryBudget={categoryBudget && categoryBudget}
          />
        )}
      </div>
      <div className="BudgetCards">
        <div className="budgetCardStyle">
          <h3
            className="Reportheading"
            style={{ fontSize: "16px", fontWeight: "600", color: "black" }}
          >
            Not Budgeted Yet
          </h3>
          <div className="listingContainer" style={{ position: "relative" }}>
            <React.Fragment>
              {uncategorizedBudget && uncategorizedBudget.length > 0 ? (
                // notYetBudgetedData
                //   .filter((item) => {
                //     const categoryName = item.categoryName;
                //     // Get the category names to skip from the state
                //     const categoryNamesToSkip =
                //       (budgetData &&
                //         budgetData.map(
                //           (item) => item.budgetCategory.categoryName
                //         )) ||
                //       [];
                //     console.log(
                //       "categoryNamesToSkip",
                //       categoryNamesToSkip,
                //       categoryName
                //     );
                //     return !categoryNamesToSkip.includes(categoryName);
                //   })
                uncategorizedBudget.map((item, index) => (
                  <div key={index} className="list-row-noBg">
                    <div className="listname-dark">
                      <div>
                        {item.categoryName}{" "}
                        {item.subCategory && `(${item.subCategory})`}
                      </div>
                      <div style={{ color: "#030229", fontWeight: "400" }}>
                        $
                        {item.amount &&
                          item.amount
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      </div>
                    </div>
                    <div
                      className="bugetStatus"
                      style={{ height: "fit-content", padding: "8px" }}
                      onClick={() => {
                        setSelectedData(item);
                        setSelectedDataNotBudgeted(item);
                        let obj = { ...item };
                        if (item.amount) {
                          // obj.amount = item.total.toFixed(2);
                          obj.amount = Math.abs(item.amount).toFixed(2);
                        }
                        if (item.subCategory) {
                          obj.categoryName = item.subCategory;
                        } else if (item.categoryName && item.categoryName) {
                          obj.categoryName = item.categoryName;
                        }
                        console.log("ghfhjkl;", obj, item);

                        setFormData(obj);
                        setAddModal(true);
                      }}
                    >
                      +
                    </div>
                  </div>
                ))
              ) : (
                <div className="nodata">No Data to Show</div>
              )}
            </React.Fragment>
            <NewLoader isLoading={loading} />
          </div>
        </div>
      </div>
    </div>
  );
};
